import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SvgComponent } from '@shared/components/svg';
import { StoreWithUuid } from '@shared/models';
import { SafeHtmlPipe } from '@shared/pipe';
import { CommonStore } from '@stores';

@Component({
  selector: 'app-no-slot-fallback-card',
  imports: [TranslatePipe, SvgComponent, SafeHtmlPipe],
  templateUrl: './no-slot-fallback-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoSlotFallbackCardComponent {
  readonly store = input.required<Partial<StoreWithUuid>>();
  readonly appointmentFunnel = inject(CommonStore).select('appointmentFunnel');
}
